import React from "react";
import { RefreshCw } from "lucide-react";
import { fmtDateTime } from "@/lib/format";

/**
 * Small chip that displays the "last successful publish" timestamp.
 * Rendered inline in the page header. Accepts either an ISO string or `null`.
 * When `autoRefreshing` is true, shows a subtle pulsing dot.
 */
export function LastUpdateChip({ ts, autoRefreshing = false, testid = "last-update-chip" }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-slate-50 border border-slate-200 text-slate-600"
      title="Ultimo aggiornamento dati dal backend"
      data-testid={testid}
    >
      <RefreshCw
        size={11}
        className={autoRefreshing ? "text-blue-500 animate-spin" : "text-slate-400"}
      />
      <span className="font-medium">
        {ts ? `Ultimo aggiornamento: ${fmtDateTime(ts)}` : "Nessun aggiornamento disponibile"}
      </span>
    </span>
  );
}

export default LastUpdateChip;
